import { History } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { REVERT_APPOINTMENT } from "../../../enums/ApiPaths";
import { STATUSES } from "../../../enums/AppointmentStatus";
import { APPOINTMENT_GENERAL } from "../../../enums/QueryKeys";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useConfirm from "../../../hooks/useConfirm";
import useUser from "../../../hooks/useUser";
import usePutAppointments from "../hooks/usePutAppointments";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { EDIT_APPOINTMENT } from "../../../enums/PermissionTitles";
import ActionRow from "../../admin/clinic/components/actions/ActionRow";
export function canRevertAppointment({ status, isConfirmed, roles }) {
  const revertableStatus =
    status == STATUSES.INACTIVE ||
    status == STATUSES.FINISHED ||
    status == STATUSES.RESOLVED ||
    status == STATUSES.ACTIVE;

  return !!isConfirmed && !roles.user && revertableStatus;
}

export default function RevertAppointment({ status, isConfirmed }) {
  const { t } = useTranslation();
  const { roles } = useUser();
  const { id } = useParams();
  const put = usePutAppointments(
    REVERT_APPOINTMENT + id,
    APPOINTMENT_GENERAL + id,
    null,
  );
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);

  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning",
  );

  if (!canRevertAppointment({ status, isConfirmed, roles })) {
    return null;
  }

  async function handleRevert() {
    switch (String(status).toUpperCase()) {
      case STATUSES.INACTIVE:
        getMessage(t("RevertFromInactiveWarning"));
        break;
      case STATUSES.FINISHED:
        getMessage(t("RevertFromFinished"));
        break;
      case STATUSES.RESOLVED:
        getMessage(t("RevertFromResolved"));
        break;
      default:
        getMessage(t("RevertFromActive"));
    }

    const ans = await confirm();
    if (ans) {
      put.submitCallback();
    }
  }

  return (
    <Fragment>
      <ActionRow
        justButton
        icon={<History />}
        label={t("RevertAppointment")}
        description={t("RevertAppointmentDesc")}
        onClick={() => handleRevert()}
        disabled={!isPermissionAllowed(EDIT_APPOINTMENT)}
        testId={"appointment.details.revert-button"}
      />

      <ConfirmationDialog />
    </Fragment>
  );
}
